"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetVerticalSrcError = exports.LoadScriptVerticalError = exports.GetVerticalError = void 0;
const LOAD_SCRIPT_ERROR = 'Load Script Error';
const GET_VERTICAL_SRC_ERROR = 'Load Script Error';
const GET_URL_VERTICAL_ERROR = 'Get URL Vertical Error';
class CustomError extends Error {
    constructor(errorType, message) {
        super(`${errorType}${message ? ` - ${message}` : ''}`);
    }
}
class GetVerticalError extends CustomError {
    constructor(message) {
        super(GET_URL_VERTICAL_ERROR, message);
        Object.setPrototypeOf(this, GetVerticalError.prototype);
        this.name = 'GetUrlVertical';
    }
}
exports.GetVerticalError = GetVerticalError;
class LoadScriptVerticalError extends CustomError {
    constructor(message) {
        super(LOAD_SCRIPT_ERROR, message);
        Object.setPrototypeOf(this, LoadScriptVerticalError.prototype);
        this.name = 'LoadScriptVertical';
    }
}
exports.LoadScriptVerticalError = LoadScriptVerticalError;
class GetVerticalSrcError extends CustomError {
    constructor(message) {
        super(GET_VERTICAL_SRC_ERROR, message);
        Object.setPrototypeOf(this, GetVerticalSrcError.prototype);
        this.name = 'GetVerticalSrc';
    }
}
exports.GetVerticalSrcError = GetVerticalSrcError;
//# sourceMappingURL=errors.js.map